import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelect({
    onChange, options, title, defaultValue
}) {
  const classes = useStyles();
  const [option, setOption] = React.useState(defaultValue);

  const handleChange = (event) => {
    setOption(event.target.value)
    onChange(event.target.value);
  };

  const getOptions = () => {
      return options.map(option => <MenuItem key={option.key} value={option.value}>{option.label}</MenuItem>)
  }

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="simple-select-label">{title}</InputLabel>
        <Select
          labelId="simple-select-label"
          id="simple-select"
          onChange={handleChange}
          value={option}
        >
         {getOptions()}
        </Select>
      </FormControl>
    </div>
  );
}
